import { apiClient } from './client';
import { User, PaginatedResponse } from '../../types';

export interface CreateUserRequest {
  userName: string;
  password: string;
  roles: string[];
  activated?: boolean;
}

export interface UpdateUserRequest {
  activated?: boolean;
}

export interface ChangePasswordRequest {
  password: string;
}

export interface GetUsersParams {
  pageIndex?: number;
  pageSize?: number;
  username?: string;
  fullName?: string;
  roles?: string[];
  activated?: boolean;
}

export const usersApi = {
  // Get users list
  getUsers: async (params?: GetUsersParams): Promise<PaginatedResponse<User>> => {
    const query = {
      ...params,
      roles: params?.roles?.length ? params.roles.join(',') : undefined,
    };
    return apiClient.get<PaginatedResponse<User>>('/api/v1/admin/users', { params: query });
  },

  // Create new user (SuperAdmin only)
  createUser: async (data: CreateUserRequest): Promise<{ success: boolean }> => {
    return apiClient.post<{ success: boolean }>('/api/v1/admin/users', data);
  },

  // Update user activation status (SuperAdmin only)
  updateUserActivation: async (userId: string, data: UpdateUserRequest): Promise<{ success: boolean }> => {
    return apiClient.put<{ success: boolean }>(`/api/v1/admin/users/${userId}/activation`, data);
  },

  // Change user password (SuperAdmin only)
  changeUserPassword: async (userId: string, data: ChangePasswordRequest): Promise<{ success: boolean }> => {
    return apiClient.put<{ success: boolean }>(`/api/v1/admin/users/${userId}/password_change`, data);
  },
};

